document.addEventListener("turbolinks:load", function() {
    // Guard Clause
    if (!document.querySelector(".cengage-builder__header")) return

    // == Helper Functions ==
    // Hide rows that don't match the search query and aren't checked off
    const filterSearch = () => {
        const searchField = document.querySelector("#cengage-builder__search");
        const searchQuery = searchField.value.trim().toLowerCase();

        const assignmentRows = document.querySelectorAll("#cengage-builder__tbody tr");
        assignmentRows.forEach(row => {
            // Show the row if it's checked off, and move on to the next row
            if (row.querySelector("input[type='checkbox']").checked) {
                row.classList.remove("cengage-builder__assignment_search-hidden");
                return;
            }
            // Show the row if any entry in a searchable row fits the search query
            const fields = Array.from(row.querySelectorAll("[data-searchable='searchable']"));
            const rowMatchFound = fields.some(field => {
                const text = field.textContent.toLowerCase();
                return text.includes(searchQuery);
            })
            if (rowMatchFound) {
                row.classList.remove("cengage-builder__assignment_search-hidden");
            } else {
                row.classList.add("cengage-builder__assignment_search-hidden");
            }
        });

        // Show or hide the message for no matching assignments as appropriate
        setNoMatchesMessage()
    }

    // Hide rows that don't match the course and aren't checked off
    const filterCourse = () => {
        // Get the selected course, and check if it's either the "Show All" or "Select a Course" option
        const courseDropdown = document.querySelector("#cengage-builder__dropdown");
        const selectedCourse = courseDropdown.value.trim().toLowerCase();
        const showAll = selectedCourse === "";

        const assignmentRows = document.querySelectorAll("#cengage-builder__tbody tr");
        assignmentRows.forEach(row => {
            // Show the row if it's checked off, and move on to the next row
            if (row.querySelector("input[type='checkbox']").checked) {
                row.classList.remove("cengage-builder__assignment_course-hidden");
                return;
            }
            // Show the row if the course name matches the selected course
            const rowCourseField = row.querySelector("[data-course='course']");
            const rowCourseName = rowCourseField.textContent.trim().toLowerCase();
            const courseMatched = selectedCourse === rowCourseName;
            if (courseMatched || showAll) {
                row.classList.remove("cengage-builder__assignment_course-hidden");
            } else {
                row.classList.add("cengage-builder__assignment_course-hidden");
            }
        });

        // Show or hide the message for no matching assignments as appropriate
        setNoMatchesMessage()
    }

    // Show the no matches message if every assignment is hidden
    const setNoMatchesMessage = () => {
        const filterString = ".cengage-builder__assignment" +
            ":not(.cengage-builder__assignment_course-hidden)" +
            ":not(.cengage-builder__assignment_search-hidden)"
        const anyMatchFound = document.querySelectorAll(filterString)
        const noMatchesMessage = document.querySelector("#cengage-builder__no-matches");
        if (anyMatchFound.length > 0) {
            noMatchesMessage.classList.add("cengage-builder__no-matches_hidden");
        } else {
            noMatchesMessage.classList.remove("cengage-builder__no-matches_hidden");
        }
    }

    // Update the count of selected assignments; disable/enable checkboxes as needed; update filters
    const handleCheckboxChange = () => {
        const submitForm = document.querySelector("#cengage-builder__form")
        // Change the count
        const checkedBoxes = submitForm.querySelectorAll(":checked");
        assignment_count.textContent = checkedBoxes.length.toString();
        // Enable or disable the unchecked boxes depending on the max (20) have been checked
        const uncheckedBoxes = submitForm.querySelectorAll(":not(:checked)");
        if (checkedBoxes.length >= 20) {
            uncheckedBoxes.forEach(checkbox => {
                checkbox.disabled = true;
            });
        }
        else if (checkedBoxes.length < 20) {
            uncheckedBoxes.forEach(checkbox => {
                checkbox.disabled = false;
            });
        }
        // Hide the assignment if appropriate
        filterCourse();
        filterSearch();
    }

    // == Page Setup ==
    // Shared DOM Queries
    const submitForm = document.querySelector("#cengage-builder__form")

    // Live Search
    let timeout = null;
    const searchField = document.querySelector("#cengage-builder__search");
    searchField.addEventListener("input", () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => filterSearch(), 80);
    });

    // Course Filtering
    // Create a new filter after selecting an option from the dropdown
    const filterDropdown = document.querySelector("#cengage-builder__dropdown");
    filterDropdown.addEventListener("change", (event) => {
        filterCourse();
    })

    // Assignment Counter and Checkbox Handler
    const assignment_count = document.querySelector("#cengage-builder__count");
    // Update whenever any checkbox changes
    submitForm.addEventListener("change", handleCheckboxChange);

    // Prevent form submission on pressing enter; the form should only be submitted by pressing the button
    submitForm.addEventListener("keydown", function (e) {
        //Prevent enter key
        if (e.key === "Enter") {
            e.preventDefault();
        }
    });
})

